import { NavigationLinkProperties } from '../../shared/model/interfaces/navigation-link-properties.interface';
import { PermissionSource } from '../../shared/model/enums/permission-source.enum';

export const navItemsProperties: NavigationLinkProperties[] = [
  {
    name: 'ROUTES.DASHBOARD',
    url: '/dashboard',
    icon: 'fal fa-home',
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.SESSIONS',
    url: '/sessions',
    icon: 'fal fa-tasks',
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.ORGANIZATIONS',
    url: '/companies',
    icon: 'fal fa-sitemap',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasCompanyShow',
      },
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasCompanyList',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.ORGANIZATION',
    url: '/company/:id',
    icon: 'fal fa-sitemap',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasCompanyShow',
      },
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasCompanyList',
        required: false,
      },
    ],
  },
  {
    name: 'ROUTES.PROJECTS',
    url: '/projects',
    icon: 'fal fa-cog',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectShow',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.INTEGRATIONS',
    url: '/integrations',
    icon: 'fal fa-plug',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectIntegrationsShow',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.ANALYTICS',
    url: '/analytics',
    icon: 'fal fa-chart-line',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectStatsShow',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.USERS',
    url: '/users',
    icon: 'fal fa-users',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectUsersUpdate',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.TEMPLATES',
    url: '/templates',
    icon: 'fal fa-file-alt',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectTemplateShow',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.PROCESSES',
    url: '/workflows2',
    icon: 'fal fa-project-diagram',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectBpmShow',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.TRANSACTIONS',
    url: '/post-transactions',
    icon: 'fal fa-upload',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectSessionCreate',
      },
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectBatchesUse',
      },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.SOURCES',
    url: '',
    icon: 'fal fa-database',
    permission: [
      {
        source: PermissionSource.USER_PROJECT_PERMISSIONS,
        key: 'hasProjectTemplateShow',
      },
    ],
    children: [
      {
        name: 'ROUTES.DICTIONARIES',
        url: '/dictionaries',
        icon: 'fal fa-list nav-inner',
        permission: [
          {
            source: PermissionSource.USER_PROJECT_PERMISSIONS,
            key: 'hasProjectDatadictionariesShow',
          },
        ],
      },
      {
        name: 'ROUTES.DATATABLES',
        url: '/texts-tables',
        icon: 'fal fa-table nav-inner',
        permission: [
          {
            source: PermissionSource.USER_PROJECT_PERMISSIONS,
            key: 'hasProjectTextsTableUse',
          },
        ],
      },
      {
        name: 'ROUTES.CATEGORIES',
        url: '/categories',
        icon: 'fal fa-folders nav-inner',
        permission: [
          {
            source: PermissionSource.USER_PROJECT_PERMISSIONS,
            key: 'hasProjectCategoriesUse',
          },
        ],
      },
    ],
  },
  {
    name: 'ROUTES.TARIFFS',
    url: '/tariffs',
    icon: 'fal fa-suitcase',
    permission: [{ source: PermissionSource.USER_DATA, key: 'isSuperuser' }],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.AUDIT-LOGS',
    url: '/audit-logs',
    icon: 'fal fa-file-medical-alt',
    permission: [{ source: PermissionSource.USER_DATA, key: 'isSuperuser' }],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
  {
    name: 'ROUTES.SUPPORT',
    url: '/service-call',
    icon: 'fal fa-headset',
    permission: [
      { source: PermissionSource.SYSTEM_SETTINGS, key: 'SUPPORT_ENABLED' },
    ],
    linkProps: {
      routerLinkActiveOptions: { exact: true }
    },
  },
];
